import { FC, HTMLAttributes, useEffect, useState } from "react";
import clsx from "classnames";
import { useStyles } from "./Radio.style";

interface IRadioProps {
  checked?: boolean;
  onChange?: (checked?: boolean) => void;
  disabled?: boolean;
}

export const Radio: FC<IRadioProps & HTMLAttributes<HTMLDivElement>> = (
  props,
) => {
  const classes = useStyles();
  const { id, checked, onChange, disabled, ...otherProps } = props;
  const [checkedInput, setCheckedInput] = useState(checked);

  const onChangeRadio = () => {
    onChange?.(!checkedInput);
    setCheckedInput(!checkedInput);
  };

  useEffect(() => {
    setCheckedInput(checked);
  }, [checked]);

  return (
    <input
      {...otherProps}
      type="radio"
      id={id || "radio"}
      onChange={onChangeRadio}
      checked={Boolean(checkedInput)}
      disabled={disabled}
      className={clsx(classes.radio)}
    />
  );
};
